module.exports = __webpack_public_path__ + "static/sponsors-50639506b1162522e453e499b9f113e6.png";